import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=10614d22"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10614d22')) {
      api.createRecord('10614d22', component.options)
    } else {
      api.reload('10614d22', component.options)
    }
    module.hot.accept("./Delete.vue?vue&type=template&id=10614d22", function () {
      api.rerender('10614d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Delete.vue"
export default component.exports